import type { FC } from "react";
import { Box, Typography } from "@mui/material";
import type { DashboardCapacityMetric } from "../types";
import { DashboardCapacityRow } from "./dashboard-capacity-row.component";

export interface DashboardCapacityCardProps {
  metrics: DashboardCapacityMetric[];
}

export const DashboardCapacityCard: FC<DashboardCapacityCardProps> = ({ metrics }) => (
  <Box className="operator-dashboard__card">
    <Box className="operator-dashboard__capacity-card-head">
      <Typography component="h2" variant="subtitle1" className="operator-dashboard__card-title">
        Capacity usage
      </Typography>
      <Typography component="p" variant="body2" className="operator-dashboard__capacity-card-head-sub">
        Filled / Available
      </Typography>
    </Box>
    <Box className="operator-dashboard__capacity-metrics-row">
      {metrics.map((m) => (
        <Box key={m.id} className="operator-dashboard__capacity-slab">
          <DashboardCapacityRow metric={m} />
        </Box>
      ))}
    </Box>
  </Box>
);
